const FETCH_PAYMENT_HISTORIES = 'paymentHistory/FETCH_PAYMENT_HISTORIES';

const RESET = 'paymentHistory/RESET';


export default {
  FETCH_PAYMENT_HISTORIES,
  RESET,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/paymentHistory/types.js